import axios from "axios";
import { downloadFile } from "../_helpers/downloadFile";
import { ApiService } from "./api.service";

export const PRDService = {
    fetchProducts,
    fetchProduct,
    fetchOrCreateProduct,
    updateProduct,
    deleteProduct,
    fetchProductComponents,
    createProductComponent,
    updateProductComponent,
    deleteProductComponent,
    getKeyMaster,
    getManufactureOrder,
    getManufactureWorkOrders,
    createManufactureOrder,
    updateManufactureOrder,
    deleteManufactureOrder,
    processManufactureOrder,
    getWorkOrderMachines,
    getActiveMachines,
    fetchManufactureOrderComponents,
    fetchManufactureOrderComponent,
    createManufactureOrderComponent,
    updateManufactureOrderComponent,
    fetchManufactureOrderComponentMachines,
    fetchComponentBatchesBySeqNumber,
    createOrUpdateManufactureOrderComponentMachine,
    updateOrderComponentAllMachines,
    fetchManufactureOrderComponentLots,
    manufactureOrderComponentLotAssignment,
    manufactureOrderComponentLotRelease,
    processProductionOrder,
    getProductionWorkOrders,
    getProductionWorkOrder,
    getProductionWorkOrderDetail,
    postProductionWorkOrderDetail,
    putProductionWorkOrderDetail,
    putProductionWorkOrderAssembly,
    deleteProductionWorkOrderDetail,
    getProductionWorkOrderLineAssembly,
    postAssignmentOrderAssemblyLot,
    getAssignedOrderAssemblyLot,
    deleteAssignedOrderAssemblyLot,
    getProductionOpenProducts,
    getProductionOpenProduct,
    createLblOrderHeader,
    deleteLblOrder,
    updateLblOrderHeader,
    processLblOrder,
    getLblOrdersHeader,
    getLblOrderHeader,
    getLblAssemblyItems,
    createLblOrderAssemblyItem,
    updateLblOrderAssemblyItem,
    deleteLblOrderAssemblyItem,
    getLblAssemblyLots,
    postLblAssemblyLot,
    deleteLblAssemblyLot,
    downloadMftHistoDetailExcel,
    downloadMftHistoMasterExcel,
    downloadProductHistoDetailExcel,
    downloadLblHistoDetailExcel,
    downloadPrdPendingLabelExcel
}

function fetchProduct(product_name, product_brand) {
  return ApiService.post(`/production/product/get`, { product_name, product_brand })
}

function fetchProducts (m_b, page, limit) {
    return ApiService.post(`/production/product/getAll/`, { m_b, page, limit })
}

function fetchOrCreateProduct (product_name, product_brand) {
    return ApiService.post(`/production/product/getOrInsert/`, { product_name, product_brand })
}

function updateProduct (id, data) {
  return ApiService.put(`/production/product/${id}`, data)
}

function deleteProduct (id) {
  return ApiService.delete(`/production/product/${id}`)
}

function fetchProductComponents (product_name, product_brand) {
    return ApiService.post(`/production/product-component/getAll`, { product_name, product_brand })
}

function createProductComponent (data) {
    return ApiService.post(`/production/product-component/`, data)
}

function updateProductComponent (id, data) {
    return ApiService.put(`/production/product-component/${id}`, data)
}

function deleteProductComponent (id) {
  return ApiService.delete(`/production/product-component/${id}`)
}

function getKeyMaster (order_number) {
    return ApiService.post('/production/getKeyMaster/', { order_number })
}

function getManufactureOrder (manufacture_type, manufacture_number) {
    return ApiService.post('/production/manufacture/getWorkOrder/', { manufacture_type, manufacture_number })
}

function getManufactureWorkOrders(page, limit) {
    return ApiService.get(`/production/manufacture/getWorkOrders?page=${page}&limit=${limit}`)
}
function createManufactureOrder (data) {
    return ApiService.post('/production/manufacture/createOrder/', data)
}
function updateManufactureOrder (data) {
    return ApiService.put('/production/manufacture/updateOrder/', data)
}
function deleteManufactureOrder (id) {
    return ApiService.delete(`/production/manufacture/deleteOrder/${id}`)
}
function processManufactureOrder (id) {
    return ApiService.post(`/production/manufacture/processOrder/`, {id})
}
function getWorkOrderMachines (manufacture_type, manufacture_number) {
    return ApiService.post('/production/manufacture/getWorkOrderMachines/', { manufacture_type, manufacture_number })
}
function getActiveMachines (id) {
  return ApiService.get(`/production/manufacture/getActiveMachines/${id}`)
}

function fetchManufactureOrderComponents (manufacture_type, manufacture_number) {
    return ApiService.post('/production/manufacture/getOrderComponents', { manufacture_type, manufacture_number })
}

function fetchManufactureOrderComponent (id) {
    return ApiService.get(`/production/manufacture/getOrderComponent/${id}`)
}
function createManufactureOrderComponent (id, product_code) {
    return ApiService.post('/production/manufacture/createComponent/', {id, product_code})
}
function updateManufactureOrderComponent (id, qty_in_machine) {
  return ApiService.put('/production/manufacture/updateComponent/', {id, qty_in_machine})
}

function fetchManufactureOrderComponentMachines (manufacture_type, manufacture_number) {
    return ApiService.post('/production/manufacture/getOrderComponentMachines', { manufacture_type, manufacture_number })
}

function fetchComponentBatchesBySeqNumber (manufacture_type, manufacture_number, component_seq_number) {
  return ApiService.post('/production/manufacture/getComponentMachineBySeqNumber', { manufacture_type, manufacture_number, component_seq_number })
}

function createOrUpdateManufactureOrderComponentMachine (id, batch, machine, qty_required) {
    return ApiService.put('/production/manufacture/updateOrderComponentMachine', { id, machine, batch, qty_required })
}

function updateOrderComponentAllMachines (id, batch, qty_required) {
  return ApiService.put('/production/manufacture/updateOrderComponentAllMachines', { id, batch, qty_required })
}

function fetchManufactureOrderComponentLots (manufacture_type, manufacture_number, component_seq_number) {
    return ApiService.post('/production/manufacture/getWorkOrderComponentLots', { manufacture_type, manufacture_number, component_seq_number })
}

function manufactureOrderComponentLotAssignment(data) {
    return ApiService.post('/production/manufacture/workOrderComponentLotAllocation', data)
}

function manufactureOrderComponentLotRelease(id) {
    return ApiService.delete(`/production/manufacture/workOrderComponentLotRelease/${id}`)
}
function getProductionWorkOrders(limit, offset) {
    return ApiService.post('/production/getWorkOrders/', {limit, offset})
}
function getProductionWorkOrder(order_number) {
    return ApiService.post('/production/getWorkOrder/', { order_number })
}
function getProductionOpenProducts(limit, offset) {
    return ApiService.post('/production/getOpenProducts/', {limit, offset})
}
function getProductionOpenProduct(data) {
    return ApiService.post('/production/getOpenProduct/', data)
}
function processProductionOrder(id) {
    return ApiService.post('/production/processOrder/', { id })
}
function getProductionWorkOrderDetail(order_number) {
    return ApiService.post('/production/getWorkOrderDetail/', { order_number })
}
function postProductionWorkOrderDetail(data) {
    return ApiService.post('/production/createOrderItem/', data)
}
function putProductionWorkOrderDetail(data) {
    return ApiService.put('/production/updateOrderItem/', data)
}
function deleteProductionWorkOrderDetail(id) {
    return ApiService.delete(`/production/deleteOrderItem/${id}`)
}
function getProductionWorkOrderLineAssembly(order_number, seq_number) {
    return ApiService.post('/production/getWorkOrderLineAssembly/', { order_number, seq_number })
}
function putProductionWorkOrderAssembly(data) {
    return ApiService.put('/production/updateWorkOrderLineAssembly', data)
}
function getAssignedOrderAssemblyLot(product_code, order_number, seq_number, qty_type) {
    return ApiService.post('/production/getAssignedAssemblyLots', { product_code, order_number, seq_number, qty_type })
}
function postAssignmentOrderAssemblyLot(data) {
    return ApiService.post('/production/assignAssemblyLot', data)
}
function deleteAssignedOrderAssemblyLot (id) {
    return ApiService.delete(`/production/deleteAssignedAssemblyLot/${id}`)
}
function createLblOrderHeader(order_number, seq_number) {
    return ApiService.post('/production/lbl/createHeader', {order_number, seq_number})
}
function deleteLblOrder(id) {
    return ApiService.delete(`/production/lbl/deleteOrder/${id}`)
}
function getLblAssemblyItems(lbl_number) {
    return ApiService.post('/production/lbl/getAssemblyItems', {lbl_number} )
}
function createLblOrderAssemblyItem(data) {
    return ApiService.post('/production/lbl/createAssemblyItem', data )
}
function updateLblOrderAssemblyItem(data) {
    return ApiService.put('/production/lbl/updateAssemblyItem', data )
}
function deleteLblOrderAssemblyItem(id) {
    return ApiService.delete(`/production/lbl/deleteAssemblyItem/${id}`)
}
function getLblOrdersHeader(order_number) {
    return ApiService.post('/production/lbl/getWorkHeaders', {order_number} )
}
function getLblOrderHeader(lbl_number) {
    return ApiService.post('/production/lbl/getWorkHeader', {lbl_number} )
}
function updateLblOrderHeader(data) {
    return ApiService.put('/production/lbl/updateHeader', data )
}
function processLblOrder(id) {
    return ApiService.post('/production/lbl/processOrder', { id } )
}
function getLblAssemblyLots(data) {
    return ApiService.post('/production/lbl/getAssemblyLots', data )
}
function postLblAssemblyLot({lot_id, lot_qty, qty_type, id},) {
    return ApiService.post('/production/lbl/assignAssemblyLot', { lot_id, lot_qty, qty_type, id })
}
function deleteLblAssemblyLot (id) {
    return ApiService.delete(`/production/lbl/deleteAssemblyLot/${id}`)
}
function downloadMftHistoDetailExcel(date1, date2, productName, productBrand) {
  return axios({
    url:`/production/manufacture/reports/downloadMftHistoryDetail?date1=${date1}&date2=${date2}&productName=${productName}&productBrand=${productBrand}`,
    method: 'GET',
    responseType: 'blob'
  })
  .then(response => downloadFile(response, `Historico ordenes fabricacion.xlsx`))
}
function downloadMftHistoMasterExcel(date1, date2) {
    return ApiService.customRequest({
      url:`/production/manufacture/reports/downloadMftHistoryMaster?date1=${date1}&date2=${date2}`,
      method: 'GET',
      responseType: 'blob'
    })
    .then(response => downloadFile(response, `Reporte Marmitas/Barriles.xlsx`))
  }
  function downloadProductHistoDetailExcel(date1, date2) {
    return ApiService.customRequest({
      url:`/production/reports/downloadProductHistoryDetail?date1=${date1}&date2=${date2}`,
      method: 'GET',
      responseType: 'blob'
    })
    .then(response => downloadFile(response, `Reporte envases.xlsx`))
  }

  function downloadLblHistoDetailExcel(date1, date2) {
    return ApiService.customRequest({
      url:`/production/lbl/reports/downloadLblHistoryDetail?date1=${date1}&date2=${date2}`,
      method: 'GET',
      responseType: 'blob'
    })
    .then(response => downloadFile(response, `Reporte etiquetas.xlsx`))
  }

  function downloadPrdPendingLabelExcel() {
    return ApiService.customRequest({
      url:`/production/reports/downloadProductPendingLabel`,
      method: 'GET',
      responseType: 'blob'
    })
    .then(response => downloadFile(response, `Productos pendiente de etiquetar.xlsx`))
  }



// WEBPACK FOOTER //
// ./src/services/prd.service.js